"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChangeLogModalComponent = exports.ChangelogModalContext = void 0;
const core_1 = require("@angular/core");
const bootstrap_1 = require("angular2-modal/plugins/bootstrap");
const angular2_modal_1 = require("angular2-modal");
const changelog_service_1 = require("./changelog.service");
class ChangelogModalContext extends bootstrap_1.BSModalContext {
}
exports.ChangelogModalContext = ChangelogModalContext;
let ChangeLogModalComponent = class ChangeLogModalComponent {
    constructor(dialog, changeLogService) {
        this.dialog = dialog;
        this.changeLogService = changeLogService;
        this.showRawJsonDiff = false;
        this.context = dialog.context;
        this.rawJsonDiff = JSON.parse(this.context.revision.diff);
        this.changes = changeLogService.parseJsonDiff(this.rawJsonDiff);
        this.modalTitle = this.context.revision.name;
    }
    expandAll() {
        this._setVisibilityRecursive(this.changes, false);
    }
    collapseAll() {
        this._setVisibilityRecursive(this.changes, true);
    }
    _setItemVisibility(i, val) {
        i.isHidden = val;
        if (i.type === 'nested') {
            this._setVisibilityRecursive(i.diffs, val);
        }
    }
    _setVisibilityRecursive(node, val) {
        if (Array.isArray(node)) {
            node.forEach(i => this._setItemVisibility(i, val));
        }
        else {
            this._setItemVisibility(node, val);
        }
    }
    closeIt() {
        this.dialog.close();
    }
    revertIt() {
        this.dialog.close(this.context.revision);
    }
};
exports.ChangeLogModalComponent = ChangeLogModalComponent;
exports.ChangeLogModalComponent = ChangeLogModalComponent = __decorate([
    (0, core_1.Component)({
        selector: 'changelog-modal',
        styleUrls: ['styles/changelog-modal.component.css'],
        templateUrl: 'app/changelog-modal.component.html'
    }),
    __metadata("design:paramtypes", [angular2_modal_1.DialogRef,
        changelog_service_1.ChangeLogService])
], ChangeLogModalComponent);
//# sourceMappingURL=changelog-modal.component.js.map